import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { LegacyServicesService } from 'src/app/services/legacy-services.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-map-page-detail',
  templateUrl: './map-page-detail.component.html',
  styleUrls: ['./map-page-detail.component.scss'],
  standalone: true
})
export class MapPageDetailComponent implements OnInit {
  @Input() lat = 0;
  @Input() long = 0;
  @Input() mapIsInThePopup = false;
  @Input() noMargin = false;

  map: any;
  marker: any;
  public L = this.legacyService.getL();

  constructor(@Inject(PLATFORM_ID) private platform: any, private legacyService: LegacyServicesService, @Inject(PLATFORM_ID) private platformId: object) {

  }

  async ngOnInit(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      if (document.getElementById('map')) {
        await this.initMap();
      }
    }
  }

  async initMap(): Promise<void> {
    const center = [this.long, this.lat];
    this.L.accessToken = environment.mapAccessToken;
    this.map = this.L.map('map', {
      center,
      zoom: 16,
      // maxZoom: 16,
      pitch: 45,
      minZoom: 11,
      // attributionControl: false, // --> nasconde logo mappa
      // preferCanvas: true
    });
    const tiles = this.L.tileLayer(
      `https://mappe.cercacasa.it/hot/{z}/{x}/{y}.png`,
      // `https://api.mapbox.com/styles/v1/cercacasa/ckpe5qu6v0hd118p6w3tdkjp1/tiles/{z}/{x}/{y}?access_token=${environment.mapAccessToken}`,
      {
        maxZoom: 19,
        zoom: 18,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      }
    );

    tiles.addTo(this.map);

    const icon = this.L.icon({
      // className: 'leaflet-div-icon ' + ('LPin-' + index).toString(),  // usare questa per cluster
      iconUrl: '../../assets/img/marker-icon.svg',
      popupAnchor: [0, -40],
      iconAnchor: [13, 40]
    });
    this.marker = this.L.marker(center, {
      icon
    }).addTo(this.map);
    // this.marker = new this.L.Marker().setLngLat([this.currentListing.location.coordinates[1], this.currentListing.location.coordinates[0]]).addTo(this.map);

    // const mapProperties = {
    //   center: new google.maps.LatLng(41.7409826, 11.4584709),
    //   zoom: 6.7,
    //   mapTypeId: google.maps.MapTypeId.ROADMAP,
    // };
    // const styles: google.maps.MapTypeStyle[] = [{
    //   featureType: 'poi',
    //   stylers: [{ visibility: 'off' }],
    // }, {
    //   featureType: 'transit',
    //   stylers: [{ visibility: 'off' }],
    // }];
    // this.map = new google.maps.Map((document.getElementById('map') as HTMLInputElement), mapProperties);
    // const lat: number = parseFloat(this.currentListing.location.coordinates[1].toString());
    // const lng: number = parseFloat(this.currentListing.location.coordinates[0].toString());
    // const pos = new google.maps.LatLng(lat, lng);
    // this.map.setOptions({ styles });
    // if (this.marker) {
    //   this.marker.setMap(null);
    // }
    // this.marker = new google.maps.Marker({
    //   position: pos,
    //   map: this.map,
    //   title: 'address',
    // });
    // this.map.setCenter(pos);
    // this.map.setZoom(16);
  }

}
